import * as React from 'react';
import { ICustomPropertiesElementsProps } from './types';
import { SelectListItem } from 'kui';
import './_CustomPropertiesElements.scss';
import { CLASS_BOARD_CARD_CUSTOM } from '../../constants';
import { CUSTOM_PROPERTY_TYPES } from '../../../../../../../../store/customProperties/constants';
import { AnalyzeRender } from '../../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`CardCustomProperties`) : null;

export function CustomPropertiesElements ({
    elements,
    onEdit,
}: ICustomPropertiesElementsProps) {
    if (analyzeRender) analyzeRender.call(`CardCustomProperties`);
    const className = CLASS_BOARD_CARD_CUSTOM;
    const classItem = className + '__item';

    return (
        <div className={className}>
            {elements.map(element => {
                return (
                    <SelectListItem
                        className={classItem}
                        key={element.id}
                        list={CUSTOM_PROPERTY_TYPES[element.type]}
                        onClick={() => onEdit(element.id)}
                    >
                        {element.name}
                    </SelectListItem>
                );
            })}
        </div>
    );
};
